import(/* webpackMode: "eager" */ "/home/ubuntu/download/69aaae194fab3d0014663bbd/socialboost/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69aaae194fab3d0014663bbd/socialboost/src/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69aaae194fab3d0014663bbd/socialboost/src/components/ui/AppIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69aaae194fab3d0014663bbd/socialboost/src/components/ui/AppLogo.tsx");
